/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-09-10 15:30:49
 * @Description: file content
 */
import React, { Component } from 'react';
import { Tabs as OriginTabs } from "@tinper/next-ui";
import { getSysFieldid } from '@platform/api';

const { TabPane: OriginTabPane } = OriginTabs;
require('./index.less');
class TabPane extends Component {
    render() {
        let { style = {}, className = '', ...others } = this.props;
        return <OriginTabPane {...others} style={{ ...style }} className={`${className} base-tab-pane`} />;
    }
}
// @hotkeys(true, { prevTab: "shift+left", nextTab: "shift+right" })
class Tabs extends Component {

    render() {
        let { children, className, flex, tabs, fieldid = "", ...others } = this.props;
        if (!Array.isArray(children)) {
            this.props.children = [children];
        }
        let onlyoneClass = '';

        if (Array.isArray(tabs)) {
            tabs.length <= 1 && (onlyoneClass = ' onlyoneTabpane');
        } else if (this.props.children.length === 1) {
            onlyoneClass = ' onlyoneTabpane';
        }
        if(fieldid){
            fieldid = fieldid + "-";
        }

        return (
            <div 
                fieldid={getSysFieldid(`${fieldid}tabs-area`)} 
                ref={obj => (this.tabsContainer = obj)} 
                className={`${className || ''} nc-tabs ${flex ? 'flex-container' : ''}`}
            >
                <OriginTabs
                    fieldid={getSysFieldid(`${fieldid}tabs-area`)}
                    ref={obj => (this.tabs = obj)} 
                    {...others}
                    className={"lightapp-component-tabs" + onlyoneClass}
                >
                    {Array.isArray(tabs)
                        ? tabs.map(({ name, key, render }) => {
                            return <TabPane tab={name} key={key}>
                                {render?.()}
                            </TabPane>;
                        })
                        : this.props.children}
                </OriginTabs>
            </div>
        );
    }
}
Tabs.TabPane = TabPane;

export default Tabs;
